import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function PrivacyPolicyTypography(): JSX.Element {
    const { t } = useTranslation();
    
    return (
      <>
        <Typography component="div" variant="h5" sx={{fontWeight:"bold"}}>
          {t('component.privacyPolicyTypography.title')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.userInformation.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.description')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.email')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.name')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.age')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.gender')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.postalCode')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.password')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.media')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.location')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.userInformation.items.cookie')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.purpose.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.description')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.registration')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.payment')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.analysis')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.notification')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.support')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.violation')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.changes')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.purpose.items.other')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.security.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.security.description')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.thirdParty.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.thirdParty.description')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.thirdParty.exceptions.intro')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.thirdParty.exceptions.outsourcing')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.thirdParty.exceptions.acquisition')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.thirdParty.exceptions.partner')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.thirdParty.exceptions.legal')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.analytics.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.analytics.description')}
        </Typography>
        <Typography component="div" variant="caption">
          <a href={t('component.privacyPolicyTypography.analytics.url')}>{t('component.privacyPolicyTypography.analytics.link')}</a>
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.changes.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.changes.description')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.contact.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.contact.description')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.contact.email.label')} <a href={`mailto:${t('component.privacyPolicyTypography.contact.email.address')}`}>{t('component.privacyPolicyTypography.contact.email.address')}</a>
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.contact.verification')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.company.name.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.company.name.value')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.company.representative.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.company.representative.value')}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t('component.privacyPolicyTypography.company.address.title')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.company.address.value')}
        </Typography>
        <Typography component="div" variant="caption">
          　
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.dates.established')}
        </Typography>
        <Typography component="div" variant="caption">
          {t('component.privacyPolicyTypography.dates.revised')}
        </Typography>
      </>
    );
};

export default PrivacyPolicyTypography;